// app/javascript/controllers/fade_in_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["card"]

    connect() {
        const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches

        // Initial state
        this.cardTargets.forEach((el) => {
            if (reducedMotion) {
                el.style.opacity = 1
                el.style.transform = "none"
            } else {
                el.style.opacity = 0
                el.style.transform = "translateY(20px)"
                el.style.willChange = "opacity, transform"
            }
        })

        if (reducedMotion) return

        // Animate all at once on page load (no scroll observer)
        requestAnimationFrame(() => {
            this.cardTargets.forEach((el) => {
                el.style.transition = "opacity 0.6s ease, transform 0.6s ease"
                el.style.opacity = 1
                el.style.transform = "translateY(0)"
            })
        })
    }
}
